<template>
    <div class="chat-message" v-bind:class="classes">
        <span id="avatar-name">Nyah:</span> {{ message }}
    </div>
</template>
<script>
    export default {
        name: 'ChatMessage',
        props: [ 'sender', 'message', 'isError' ],
        computed: {
            classes: function() {
                var arr = [ this.sender + '-msg' ];
                if(this.isError) arr.push('error-msg');
                return arr;
            }
        }
    }
</script>
<style lang="stylus">
    .chat-message
        font-size: 1em
        margin: 0
        text-align: left
        // content: "Nyah: "
        &.user-msg
            font-weight: bold
            color: #e3f0b6
            // content: "You: "
        &.error-msg
            color: #dd554a
        #avatar-name
            font-weight:bold
</style>